// src/pages/auth/Register.js
import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import axios from '../../utils/axios';
import { FiMail, FiLock, FiUser, FiPhone, FiMapPin, FiEye, FiEyeOff } from 'react-icons/fi';

const Register = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    phone: '',
    password: '',
    confirmPassword: '',
    full_name: '',
    address: ''
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Password match шалгах
    if (formData.password !== formData.confirmPassword) {
      toast.error('Нууц үг таарахгүй байна');
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post('/api/auth/register', {
        email: formData.email,
        phone: formData.phone,
        password: formData.password,
        full_name: formData.full_name,
        address: formData.address,
        role_id: 2 // 2 = customer
      });
      
      if (response.data.success) {
        toast.success('Амжилттай бүртгэгдлээ! Админ баталгаажуулах хүртэл хүлээнэ үү.');
        setTimeout(() => {
          navigate('/login');
        }, 2000);
      }
    } catch (error) {
      const message = error.response?.data?.message || 'Алдаа гарлаа';
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-container max-w-xl">
        {/* Logo */}
        <div className="auth-logo">
          <div className="auth-logo-icon">
            <img src="/logo.png" alt="Logo" />
          </div>
          <h1 className="auth-title">Бүртгүүлэх</h1>
          <p className="auth-subtitle">Шинэ хэрэглэгчийн бүртгэл үүсгэх</p>
        </div>

        {/* Register Card */}
        <div className="auth-card">
          <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {/* Full Name */}
              <div className="auth-form-group">
                <label className="auth-label">Нэр</label>
                <div className="auth-input-wrapper">
                  <div className="auth-input-icon">
                    <FiUser size={18} />
                  </div>
                  <input
                    type="text"
                    name="full_name"
                    value={formData.full_name}
                    onChange={handleChange}
                    className="auth-input"
                    placeholder="Нэр"
                    required
                  />
                </div>
              </div>

              {/* Phone */}
              <div className="auth-form-group">
                <label className="auth-label">Утас</label>
                <div className="auth-input-wrapper">
                  <div className="auth-input-icon">
                    <FiPhone size={18} />
                  </div>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    className="auth-input"
                    placeholder="99001122"
                  />
                </div>
              </div>
            </div>

            {/* Email */}
            <div className="auth-form-group">
              <label className="auth-label">Имэйл хаяг</label>
              <div className="auth-input-wrapper">
                <div className="auth-input-icon">
                  <FiMail size={18} />
                </div>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="auth-input"
                  placeholder="example@email.com"
                  required
                />
              </div>
            </div>

            {/* Address */}
            <div className="auth-form-group">
              <label className="auth-label">Хаяг</label>
              <div className="auth-input-wrapper">
                <div className="auth-input-icon">
                  <FiMapPin size={18} />
                </div>
                <input
                  type="text"
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                  className="auth-input"
                  placeholder="Улаанбаатар хот"
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {/* Password */}
              <div className="auth-form-group">
                <label className="auth-label">Нууц үг</label>
                <div className="auth-input-wrapper">
                  <div className="auth-input-icon">
                    <FiLock size={18} />
                  </div>
                  <input
                    type={showPassword ? 'text' : 'password'}
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    className="auth-input pr-10"
                    placeholder="••••••••"
                    required
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600"
                  >
                    {showPassword ? <FiEyeOff size={18} /> : <FiEye size={18} />}
                  </button>
                </div>
              </div>

              {/* Confirm Password */}
              <div className="auth-form-group">
                <label className="auth-label">Нууц үг давтах</label>
                <div className="auth-input-wrapper">
                  <div className="auth-input-icon">
                    <FiLock size={18} />
                  </div>
                  <input
                    type={showConfirmPassword ? 'text' : 'password'}
                    name="confirmPassword"
                    value={formData.confirmPassword}
                    onChange={handleChange}
                    className="auth-input pr-10"
                    placeholder="••••••••"
                    required
                  />
                  <button
                    type="button"
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600"
                  >
                    {showConfirmPassword ? <FiEyeOff size={18} /> : <FiEye size={18} />}
                  </button>
                </div>
              </div>
            </div>

            {/* Terms */}
            <div className="mb-6">
              <label className="flex items-start cursor-pointer">
                <input
                  type="checkbox"
                  className="checkbox mt-0.5"
                  required
                />
                <span className="ml-2 text-xs text-gray-600">
                  Би үйлчилгээний нөхцөл болон нууцлалын бодлогыг уншиж,
                  зөвшөөрч байна
                </span>
              </label>
            </div>

            {/* Submit */}
            <button
              type="submit"
              disabled={loading}
              className="btn btn-primary w-full"
            >
              {loading ? (
                <>
                  <div className="spinner mr-2"></div>
                  Бүртгэж байна...
                </>
              ) : (
                'Бүртгүүлэх'
              )}
            </button>
          </form>

          {/* Divider */}
          <div className="auth-divider">
            <span>эсвэл</span>
          </div>

          {/* Login Link */}
          <div className="text-center">
            <p className="text-sm text-gray-600">
              Бүртгэлтэй юу?{' '}
              <Link to="/login" className="auth-link">
                Нэвтрэх
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;